
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const DoctorPage = lazy(() => import('../pages/doctor/page'));
const AccessPage = lazy(() => import('../pages/access/page'));
const NewsPage = lazy(() => import('../pages/news/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/doctor',
    element: <DoctorPage />,
  },
  {
    path: '/access',
    element: <AccessPage />,
  },
  {
    path: '/news',
    element: <NewsPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
